import React, { useCallback, useContext } from 'react'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import Group from 'components/utils/Group'
import FilterChip from 'LuxKit/Chips/FilterChip'
import { getCurrentDateLabel } from '../../FlashHotel/FlashHotelMobileVariant/FlashHotelMobileVariantUtils'
import LineCalendarIcon from 'LuxKit/Icons/line/LineCalendarIcon'
import ModalContext from 'contexts/ModalContext'
import ModalBase from 'LuxKit/Modal/ModalBase'
import OfferSidebarDatePicker from 'components/OfferPage/Filters/SidebarDatePicker/OfferSidebarDatePicker'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { BusinessTravellerMultiRoomHotelsOfferPageMobile, BusinessTravellerMultiRoomHotelsOfferPageMobileDisabled } from 'businessTraveller/components/select-traveller/multi-room-hotels'
import BusinessTravellerAccountGuard from 'businessTraveller/components/BusinessTravellerAccountGuard'
import BusinessTravellerSelectLoadingSkeleton from 'businessTraveller/components/select-traveller/BusinessTravellerSelectLoadingSkeleton'

interface Props {
  dateLabel: string;
}

function AlwaysOnMobileStickyHeaderFilters(props: Props) {
  const {
    dateLabel,
  } = props

  const dispatch = useOfferPageDispatch()
  const showModal = useContext(ModalContext)

  const onClose = useCallback(() => {
    dispatch({ type: OfferPageActions.closeHeaderFilter })
  }, [dispatch])

  const onOpenCalendar = useCallback(() => {
    dispatch({ type: OfferPageActions.toggleHeaderFilter, filter: 'checkin' })

    showModal((resolve) => <ModalBase mode="drawer">
      <form onSubmit={e => {
        e.preventDefault()
        resolve()
      }}
      >
        <OfferSidebarDatePicker />
      </form>
    </ModalBase>).then(onClose)
  }, [dispatch, showModal, onClose])

  return (
    <Group direction="horizontal" gap={8} wrap="wrap">
      <BusinessTravellerAccountGuard
        employeeRoles={['BUSINESS_ADMIN', 'BUSINESS_MANAGER']}
        loading={<BusinessTravellerSelectLoadingSkeleton />}
        fallback={<BusinessTravellerMultiRoomHotelsOfferPageMobileDisabled />}
      >
        <BusinessTravellerMultiRoomHotelsOfferPageMobile />
      </BusinessTravellerAccountGuard>
      <FilterChip
        startIcon={<LineCalendarIcon />}
        size="medium"
        onClick={onOpenCalendar}
      >
        {dateLabel || 'Anytime'}
      </FilterChip>
    </Group>
  )
}

export default withOfferPageAndReduxState((state) => ({
  dateLabel: getCurrentDateLabel(state),
}), AlwaysOnMobileStickyHeaderFilters)
